<template>
  <div>
      <nav class="navbar navbar-fixed navbar-default bootsnav" style="border-bottom:none; ">
         <div class="container">
              <!-- Start Atribute Navigation -->
            <!--  <div class="attr-nav visible-xs visible-sm">
                 <ul>
                     <li><a href="/" data-toggle="modal" data-target="#ModalInicioSesion"><i class="fa fa-user"></i></a></li>
                 </ul>
              </div>-->
              <div class="navbar-header">
                  <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                      <i class="fa fa-bars"></i>
                  </button>
                  <a class="navbar-brand" href="/"><img src="./assets/images/brand/logo_whoiswho.png" class="logo" alt=""></a>
              </div>


              <div class="collapse navbar-collapse" id="navbar-menu">
                    <!-- Web -->
                    <ul class="nav navbar-nav navbar-right visible-md visible-lg" data-in="fadeInDown" data-out="fadeOutUp">
                       <!-- <li class="active" style="color=:#ffffff;"><a href="#">LO MÁS TOP</a></li>-->
                        <li class="dropdown cart-list" >
                           <router-link :to="{ name: 'Compradores', params: { section: 1 }}">COMPRADORES</router-link>
                        </li>

                         <li class="dropdown cart-list" >
                            <router-link :to="{ name: 'Distribuidores', params: { section: 2 }}">DISTRIBUIDORES</router-link>
                        </li>

                         <li class="dropdown cart-list" >
                            <router-link :to="{ name: 'Productores', params: { section: 3 }}">PRODUCTORES</router-link>
                        </li>

                         <li class="dropdown cart-list" >
                            <router-link :to="{ name: 'Dobladores', params: { section: 12 }}">DOBLADORES</router-link>
                        </li>

                          <li class="dropdown cart-list" >
                            <router-link :to="{ name: 'Ingenieros', params: { section: 13 }}">INGENIEROS</router-link>
                        </li>


                         <!-- <li class="dropdown">
                             <a href="#" class="dropdown-toggle" data-toggle="dropdown">OTT</a>
                             <ul class="dropdown-menu cart-list  hidden-xs">
                                <li class="dropdown cart-list" v-for="(item,key,index) in categoriasOtt"  >
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h6>    
                                                                      
                                     <router-link :to="{ name: getNameOtt(item.Descripcion,item.ID), params: { section: item.ID  }}" v-html="item.Descripcion" 
                                     > </router-link>
                                            </h6>
                                        </div>
                                        </div>
                                </li>
                            </ul>
                        </li> -->

                        
                        <!--<li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">VER MÁS</a>
                            <ul class="dropdown-menu cart-list  hidden-xs">
                                <li>
                                    <div class="row">
                                        <div class="col-md-12">
                                               <h6 v-for="(item,key,index) in sections.sections" v-if="(typeof  sections.sections !== 'undefined' )"  >
                                                          <router-link :to="'/otros/'+item.IDCompanyWWSection" v-html="item.Descripcion"></router-link></h6>
                                            </div>
                                        </div><!-- end col-3 -->
                                       <!-- <div class="col-menu col-md-9">
                                            <div class="tab-content">
                                                <!-- Megamenu Compradores -->
                                                <!--<div :id="'sections-'+item.IDCompanyWWSection" class="tab-pane fade" :class="( index == 0 ) ? 'in active' : ''" v-for="(item,key,index) in sections.sections" v-if="(typeof  sections.sections !== 'undefined' )"   >
                                                    <div class="row" align="center">
                                                        <h3 class="title" v-html="item.Descripcion" ></h3>
                                                    </div>
                                                    <div class="row" >
                                                        <div class="col-md-3" align="center"  v-for="(cont,index) in sections.contacts[item.IDCompanyWWSection]" v-if="(typeof  sections.contacts[item.IDCompanyWWSection] !== 'undefined' ) "  >
                                                            <div class=" imagen-megamenu ">
                                                                <router-link :to="'/contacto/'+cont.IdContactFM" >
                                                                    <div class="feat-image" :style="'background-image:url(https://images.produ.com/ww/'+getFirstImg(cont.Images)+')'" ></div>
                                                                </router-link>
                                                            </div>
                                                            <h4><router-link :to="'/contacto/'+cont.IdContactFM" v-html="(cont.FirstName+' '+cont.LastName).substring(0, 25)" >   </router-link></h4>
                                                            <h5><router-link :to="'/contacto/'+cont.IdContactFM" v-html="cont.FirstName" >  </router-link></h5>
                                                            <h6 v-html="cont.Title" ></h6>
                                                        </div>
                                                    </div>
                                                    <hr>
                                                    <div class="row" align="center">
                                                         <h5 align="center">
                                                            <router-link :to="'/otros/'+item.IDCompanyWWSection"   >
                                                                VER TODOS
                                                            </router-link>

                                                         </h5>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                </li>
                            </ul>
                        </li>-->

                        <!--<li class="dropdown cart-list" >
                            <a href="#"  data-toggle="dropdown"><i class="fa fa-user"></i></a>
                            <ul class="dropdown-menu cart-list list-amp hidden-xs">
                                <li align="center">
                                    <img src="./assets/images/img_sesion.png" class="img-sesion"/>
                                    <p>Si ya es usuario, por favor ingrese su usuario y clave</p>
                                </li>
                                <li align="center">
                                    <form action="/action_page.php">
                                        <div class="form-group">
                                            <input type="email" class="form-control" id="email" placeholder="Usuario">
                                        </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control" id="pwd" placeholder="contraseña">
                                        </div>
                                    </form>
                                    <p>Olvido su <a href=""><strong> Contraseña?</strong></a> </p>
                                    <p>No tienes cuenta? <a href=""><strong> Registrate</strong></a> </p>
                                </li>
                                <li class="total" align="center">
                                    <h6><a href="">Iniciar Sesión</a></h6>
                                </li>
                            </ul>
                        </li>-->

                       <!--  <li class="dropdown cart-list" >
                        <a href="#"  data-toggle="dropdown"><i class="fa fa-user"></i></a>
                        <ul class="dropdown-menu cart-list list-amp hidden-xs">
                            <li align="center">
                                <img src="./assets/images/img_sesion.png" class="img-sesion"/>
                                <p>Si ya es usuario, por favor ingrese su usuario y clave</p>
                            </li>
                            <li align="center">
                                <form action="/action_page.php">
                                    <div class="form-group">
                                        <input type="email" class="form-control" id="email" placeholder="Usuario">
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control" id="pwd" placeholder="contraseña">
                                    </div>
                                </form>
                                <p>Olvido su <a href=""><strong> Contraseña?</strong></a> </p>
                                <p>No tienes cuenta? <a href=""><strong> Registrate</strong></a> </p>
                            </li>
                            <li class="total" align="center">
                                <h6><a href="">Iniciar Sesión</a></h6>
                            </li>
                        </ul>
                    </li>-->

                    </ul>

                    <!-- Mobil-->
                    <ul class="nav navbar-nav navbar-right visible-sm visible-xs" data-in="fadeInDown" data-out="fadeOutUp">
                        <!--<li class="active" style="color=:#ffffff;"><a href="#">LO MÁS TOP  </a></li>-->
                        <li class="dropdown" v-for="(item,key,index) in sections.sections" if="(typeof  sections.sections !== 'undefined' )" >

                            <router-link :to="{ name: capitalizeFirstLetter(item.Descripcion), params: { section: item.IDCompanyWWSection }}" @click.native="closeMenu"  v-html="item.Descripcion" v-if="item.IDCompanyWWSection==1 || item.IDCompanyWWSection==2 || item.IDCompanyWWSection==3 || item.IDCompanyWWSection==12 ||  item.IDCompanyWWSection==13"   ></router-link>
                        </li>
                        <!-- <li class="dropdown child-ott">
                             <a href="#" class="dropdown-toggle" data-toggle="dropdown">OTT</a>
                             <ul class="dropdown-menu">
                                <li class="dropdown cart-list" v-for="(item,key,index) in categoriasOtt"  >
                                    
                                    <router-link :to="{ name: getNameOtt(item.Descripcion,item.ID), params: { section: item.ID  }}" v-html="item.Descripcion.toUpperCase()" @click.native="closeMenu" :style="'color: #6f6f6f;border-bottom:#337ab7;font-weight:bold'"
                                     > </router-link>
                                      
                                </li>
                            </ul>
                        </li> -->

                    </ul>
              </div>
          </div>
      </nav>

    <!--Termina Header -->

    <router-view></router-view>

    <!-- Footer -->
   <div class="footer">
       <div class="footer-superior">
           <div class="container">
               <div class="row">
                   <img src="./assets/images/img_pb_produ.png">
               </div>
               <div class="row icons-redes">
                   <ul class="list-inline">
                       <li><a href=""><i class="fa fa-facebook"></i></a></li>
                       <li><a href=""><i class="fa fa-twitter"></i></a></li>
                       <li><a href=""><i class="fa fa-youtube"></i></a></li>
                       <li><a href=""><i class="fa fa-linkedin"></i></a></li>
                       <li><a href=""><i class="fa fa-instagram"></i></a></li>
                   </ul>
               </div>
           </div>
       </div>
       <div class="footer-inferior">
           <div class="container">
               <div class="row">
                   <ul class="list-inline">
                      <li v-for="(sec,index) in sections.sections" if="(typeof  sections.sections !== 'undefined' )" >
                          <router-link :to="'/otros/'+sec.IDCompanyWWSection"  v-html="sec.Descripcion"></router-link>
                      </li>
                   </ul>
               </div>
           </div>
       </div>
   </div>


  </div>
</template>

<script>

var resfulApi="https://backend.produ.com/admin/index.php/welcome/";
//var resfulApi="http://produbackend/admin/index.php/welcome/";

import axios from 'axios';

export default {
  name: 'App',
  data () {
    return {
      sections: [],
      contacts: [],
      currentDate: new Date().toISOString().substring(0, 10),
      countriesHome:[],
      categoriesHome: [],
      activitiesHome: [],
      categoryInHome: 0,
      contactoInHome: '',
      empresaInHome: '',
      countryInHome: 0,
      activityInHome: 0,
      ott_vod:[],
      categoriasOtt:''

    }
  },
  created () {
      
  },methods: {
    moment: function () {
      return moment();
    },
    closeMenu: async function(){

    $('#navbar-menu').removeClass('collapse in').addClass('collapse');
    $('.navbar-header button i').removeClass('fa-times').addClass('fa-bars');

    },

    getSectionsWWFWS: async function(){

      axios.post(resfulApi+'getSectionsWWFWS', {
        token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@"
      }).then((response)  =>  {
          this.sections = response.data
          this.$nextTick(function(){
              this.loadJqueryNavheader()
          })
        }, (error)  =>  {
      })
    },
    advanceSearchHome: async function() {
        $('#myModalHome').modal('hide');
        this.$router.push('/advancesearch/'+this.contactoInHome+'_'+this.empresaInHome+'_'+this.countryInHome+'_'+this.categoryInHome+'_'+this.activityInHome)

    },
    getDataModalHome: async function(){

      await axios.post(resfulApi+'getCountriesWWFWS', {
         token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@"
       }).then((response)  =>  {
         this.countriesHome =response.data.countries
         this.categoriesHome = response.data.categories

         this.$nextTick(function(){

         })
      })

      this.getActivityHome()
    },
    getActivityHome: async function(){
      this.activityInHome=0
      if(this.categoryInHome){

          await axios.post(resfulApi+'getActivitiesByCategoryWWFWS', {
             token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@",
             category: this.categoryInHome
           }).then((response)  =>  {
             this.activitiesHome =response.data
             this.$nextTick(function(){

             })
         })
      }
    },
    getCategoriasOTTWWFWS: async function(){

      axios.post(resfulApi+'getCategoriasOTTWWFWS', {
        token: "c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@"
      }).then((response)  =>  {
          this.categoriasOtt = response.data
          console.log(response.data)
          this.$nextTick(function(){
            
          })
        })
      },
    },
  beforeMount() {
  },
  mounted: function () {
    this.getSectionsWWFWS()
    this.getCategoriasOTTWWFWS()
  },
  
}
</script>

<style>
  .navbar_header_888 a img{
      height: 64px !important;
  }


  .single_comments a:hover{
      text-decoration: underline;
  }

  .container-form-who-who{
      position: relative;
      z-index: 10000;
      background: #ffffff;
  }

  .error_form{
    border: red 1px solid !important;
  }

  @media only screen and (max-width: 650px) {
      .content_simple_search{
          float: left;
          top: -5px;
      }

      .contact-search-content h1, .simple-search-record, h2 {
          text-align: center !important;
      }


      .container-who-who{
          bottom: -52px;
      }

      .navbar-nav>li{
          padding-bottom: 3px;
      }

  }

</style>



// WEBPACK FOOTER //
// src/App.vue